import { useProdutosContext } from '../contexts/ProdutosContext'

export function useConferirTodosOsProdutos() {
  return useProdutosContext()
}
